<template>
  <div class="home">
    <img alt="Vue logo" :src="require('../assets/logo.svg')" />
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>
